var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[(_vm.backLink)?_c('router-link',{staticClass:"btn backlink",attrs:{"to":_vm.backLink}},[_vm._v("←")]):_vm._e(),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title ? _vm.title : 'Emma'))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }